import { ChangeDetectorRef, Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Subject } from 'rxjs';
import { SiteDataService } from '../services/site-data.service';
@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    imports: []
})
export class FooterComponent implements OnInit, OnDestroy {
	private siteDataService = inject(SiteDataService);
	private cdr = inject(ChangeDetectorRef);

	private unsubscribe$ = new Subject<void>();

	year = new Date().getFullYear();
	languages: { name: string; code: string; icon: string }[] = [
    	{ name: 'English', code: 'EN', icon: '' },
    	{ name: 'Spanish', code: 'ES', icon: '' },
	];

	private _selectedLanguage: { name: string; code: string; icon: string };
	public get selectedLanguage() {
    	return this._selectedLanguage;
	}

	public set selectedLanguage(newValue) {
    	this._selectedLanguage = newValue;
    	this.changeLanguage(this._selectedLanguage);
	}

	ngOnInit(): void {
    	this.buildFooter();


    	// this.translate.onLangChange.subscribe((newLang) => {
    	// 	this._selectedLanguage = this.languages.find((f) => f.code === newLang.lang);
    	// 	this.cdr.markForCheck();
    	// });

	}

	buildFooter(): void {

	}

	ngOnDestroy(): void {
    	this.unsubscribe$.next();
    	this.unsubscribe$.complete();
	}

	changeLanguage(newLang: { name: string; code: string; icon: string }) {

	}
	jpgCheck(): boolean {
    	let result = false;

    	return result;
	}
}
